// * for global variables 

export const selectOptions = [
  'Beach',
  'Mountains',
  'Ocean',
  'Lake',
  'Forest',
  'Desert',
  'Meadow',
  'Valley',
  'Cliff'
]

export const continentOptions = [
  'Africa',
  'Asia',
  'Europe',
  'North America',
  'South America',
  'Antarctica',
  'Oceania'
]

export const oceanOptions = [
  'Arctic Ocean',
  'Atlantic Ocean',
  'Indian Ocean',
  'Pacific Ocean',
  'Meditaranian Sea'
]